import { createFileRoute, notFound } from "@tanstack/react-router";
import homeStyles from "../styles/platform-home.css?url";
import type { StructuredData } from "../../src/lib/structured-data";
import { withStylesheet } from "../lib/head";
import { platformPageHead, platformShellFrom } from "../platform/head";
import { PricingPage } from "../platform/pricing-page";
import { loadPricingPage } from "../platform/product-pages";

/** Drate's pricing page (/pricing), in the homepage's look; a 404 on creator sites. */
export const Route = createFileRoute("/pricing")({
  loader: async () => {
    const page = await loadPricingPage();
    if (!page) throw notFound();
    return page;
  },
  head: ({ matches, loaderData }) =>
    loaderData
      ? withStylesheet(
          platformPageHead(platformShellFrom(matches), {
            pathname: "/pricing",
            ...(loaderData.regular
              ? {
                  title: "Pricing: Regular and Pro Plans | Drate",
                  description:
                    "Your own membership website from $9 a month. Compare Drate Regular and Pro, which adds your own iPhone and Android app and promo videos made for you.",
                }
              : {
                  title: "Pricing: Start Free, Upgrade Anytime | Drate",
                  description:
                    "Start your own membership website for free. Compare Drate Free and Pro, which adds your own iPhone and Android app and promo videos made for you.",
                }),
            canonicalPath: "/pricing",
            structuredData: JSON.parse(loaderData.structuredData) as StructuredData[],
          }),
          homeStyles,
        )
      : {},
  component: PricingRoute,
});

function PricingRoute() {
  return <PricingPage regular={Route.useLoaderData().regular} />;
}
